import type { FilterDefinition } from '@/types/FilterDefinitions'
import type { ZoneFilter } from '@futureecom/futureecom-js/dist/services/zone-service'

export const zoneFilters: FilterDefinition<ZoneFilter>[] = [
  { type: 'text', code: 'label', label: 'Label' },
  { type: 'text', code: 'code', label: 'Code' },
  { type: 'date', code: 'created_at', label: 'Created At' },
  { type: 'date', code: 'updated_at', label: 'Updated At' }
]
